<template>
    <div :class="{
            'icon btn-ai btn btn-sm btn-secondary': true,
            'disabled': disabled,
            'generating': generating
        }"
         :role="disabled ? '' : 'button'"
         @click="handleClick">

        <span v-if="icon" class="position-relative">
            <i :class="['fi', icon]"></i>
            <div class="stars">
                <div class="item">★</div>
                <div class="item">★</div>
                <div class="item">★</div>
            </div>
        </span>

        <span v-if="text" v-html="text"></span>

        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "AIButton",
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        generating: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            required: false,
            default: ''
        },
        text: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {
        handleClick() {
            this.$emit('click');
        },
    }
}
</script>
